import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
//import { validateToken } from "../../store/slices/authSlice";
import { LoadingSpinner } from "../common/LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles = [],
}) => {
  const location = useLocation();
  const { isAuthenticated, user, loading } = useAppSelector(
    (state) => state.auth
  );

  //console.log(isAuthenticated, user); // Debug log

  if (loading) {
    //console.log("Loading in progress");
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // If not authenticated or token invalid, redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate to="/auth/signin" state={{ from: location.pathname }} replace />
    );
  }

  // If role is not allowed, redirect to home page
  if (
    allowedRoles.length > 0 &&
    (!user?.role || !allowedRoles.includes(user.role))
  ) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
